<div class="row">
  <div class="col-sm-12 col-md-6 col-md-offset-3" *ngIf="gridOptions !== null">
    <div class="alert valign-children-middle" *ngIf="errorMsg">
      <div class="alert-error" aria-label="Alert.">
        <i class="icon-badgealert" aria-hidden="true"></i>
      </div>
      <div>
        <h2>Error</h2>
        <p>{{errorMsg}}</p>
      </div>
    </div>
    <div *ngIf="!isError">
      <h2 class="bulk-review">We found {{paginations.totalRecords}} records. The following users will be added </h2>
      <!--<div>We found {{paginations.totalRecords}} records</div>-->
    </div>
    <p *ngIf="isError">
      We found some errors in the file. Correct the errors and <a href="javascript:void(0)" class="" (click)="cancel();">upload your file again</a>
      <br>
      <br> {{paginations.totalRecords}} errors were found
    </p>
    <app-customgrid [gridOptions]="gridOptions"></app-customgrid>
    <hr class="mar-tb-30 hide-sm" />
    <div class="line-footer text-right">
      <button class="btn btn-secondary btn-sm-block pull-right" [checkImpersonator]="csrPermissionSubmitButton || isError" (click)="submit();"
        aria-label="Submit.">Submit</button>
      <a href="javascript:void(0)" class="btn btn-sm-block btn-link" (click)="cancel();">Back</a>
    </div>
  </div>
</div>